import { Trans, useTranslation } from 'react-i18next';

import { ReactComponent as WarningIcon } from '../../../../../../../../../assets/icons/warning.svg';
import RadioCard from '../../../../../../../../../shared/components/Cards/RadioCard/RadioCard';
import BannerFill from '../../../../../../../../../shared/components/Globals/BannerFill/BannerFill';
import { TRANSLATIONS_QUOTES } from '../../../../../../../../../shared/translations/quotes';
import './CensusMismatchOverStep.scss';

type MismatchOverOption = 'update' | 'upload-different';

export interface CensusMismatchOverStepProps {
  mismatchCount: number;
  employeeHeadcount: number;
  selectedOption: MismatchOverOption | null;
  onOptionChange: (option: MismatchOverOption) => void;
}

export default function CensusMismatchOverStep({
  mismatchCount,
  employeeHeadcount,
  selectedOption,
  onOptionChange
}: Readonly<CensusMismatchOverStepProps>) {
  const { t } = useTranslation();

  return (
    <div className="census-step">
      <BannerFill
        variant="warning"
        icon={<WarningIcon />}
        inline
        title={t(TRANSLATIONS_QUOTES.create.censusModal.mismatchOverBannerTitle)}
      />

      <p className="census-mismatch-over__body">
        <Trans
          i18nKey={TRANSLATIONS_QUOTES.create.censusModal.mismatchBody}
          values={{ mismatchCount, hc: employeeHeadcount }}
          components={{ strong: <strong /> }}
        />
      </p>
      <p className="census-mismatch-over__prompt">{t(TRANSLATIONS_QUOTES.create.censusModal.mismatchPrompt)}</p>
      <div className="census-mismatch-over__options" role="radiogroup">
        <RadioCard
          selected={selectedOption === 'update'}
          label={
            <span className="census-mismatch-over__label">
              <span>{t(TRANSLATIONS_QUOTES.create.censusModal.mismatchUpdateTitle, { mismatchCount })}</span>
              <span className="census-mismatch-over__option-sub">
                {t(TRANSLATIONS_QUOTES.create.censusModal.mismatchUpdateSub)}
              </span>
            </span>
          }
          onSelect={() => onOptionChange('update')}
        />
        <RadioCard
          selected={selectedOption === 'upload-different'}
          label={
            <span className="census-mismatch-over__label">
              <span>{t(TRANSLATIONS_QUOTES.create.censusModal.mismatchDifferentTitle)}</span>
              <span className="census-mismatch-over__option-sub">
                {t(TRANSLATIONS_QUOTES.create.censusModal.mismatchDifferentSub, { hc: employeeHeadcount })}
              </span>
            </span>
          }
          onSelect={() => onOptionChange('upload-different')}
        />
      </div>
    </div>
  );
}
